import React from 'react';
import { Modal } from 'react-bootstrap';

const DemoModal = (props) => {
    return (
        <React.Fragment>
            <Modal show={props.show} onHide={() => props.setShow(false)} centered className="popupwrapper mm_model1 cp p-0">
                <Modal.Body className='text-center pb-4 mm50'>
                    <div className='text-end mouse' onClick={() => props.setShow(false)}>&#x2715;</div>
                    <h2 className='cpm mtn_10'>Register now, it’s Free!</h2>
                    <p className='regModal mb-4'>
                        This <span className='cpm'>feature</span> is available only for registered users.
                        Please Register or Login to customise, Publish &amp; get full access to your website.</p>
                    <a target="_blank" rel="noreferrer" href={global.duUrl+"register"} className='bg_green_clr px-4 py-2 fs_14 br_5 cpm'>REGISTER NOW</a>

                </Modal.Body>
            </Modal>
        </React.Fragment>
    );
};

export default DemoModal;
